export enum StatusTransaction {
    TransactionCreate = 1,
    TransactionIdentityConfirmed = 2,
    TransactionIdentityRejected = 3,
    TransactionAmountSet = 4,
    TransactionValidated = 5,
    TransactionCancelled = 6,
    TransactionExpired = 7,
    TransactionError = 8,
    TransactionToBeCancelled = 9,
    TransactionTransfered = 10
  }
